import { render, staticRenderFns } from "./landingPage.vue?vue&type=template&id=4be9c4ac&scoped=true&"
import script from "./landingPage.vue?vue&type=script&lang=js&"
export * from "./landingPage.vue?vue&type=script&lang=js&"
import style0 from "./landingPage.vue?vue&type=style&index=0&id=4be9c4ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be9c4ac",
  null
  
)

export default component.exports